export const ComponentsContent = {
  LineDelve: {
    removeGuest: {
      title: "",
      content: "",
      labelClose: "CANCEL",
      closeAction: () => {console.log("")},
      closeActionDisable: false,
      modalActionDisable: false,
      labelAction: "REMOVE GUEST",
      isPending: false,
      closeBtnClass: "modelCloseBtn",
      actionBtnClass: "orangeButton",
      dialogClass: "",
    },
  },
  NumberCard: {
    sharedLines: {
      unpairLine: {
        title: "Unpair Device",
        content: "",
        labelClose: "CANCEL",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        labelAction: "UNPAIR DEVICE",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "",
      },
      pairLine: {
        title: "Pair your device",
        content:
          "$device_name is being $pairedData. This may take a minute.",
        labelClose: "CANCEL",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: true,
        labelAction: "PAIR",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "",
      },
      alreadyPairedLine: {
        title: "Pair your device",
        content: "$device_name is already $pairedData",
        labelClose: "",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        labelAction: "CLOSE",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "",
      },
      invitaion: {
        title: "Share line $DeviceName",
        content:
          "Share this line with someone by adding their email address below.",
        labelClose: "CANCEL",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: true,
        labelAction: "SEND INVITATION",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "",
      },
      resend: {
        title: "Share line $DeviceName",
        content: "Resend invitation",
        labelClose: "CANCEL",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: true,
        labelAction: "SEND INVITATION",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "",
      },
      serverBusy: {
        title: "Server Busy",
        content:
          "The invitation did not reach the recipient at $email. Please wait a moment and try again.",
        labelClose: "CANCEL",
        labelAction: "TRY AGAIN",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel",
      },
      deactivateLine: {
        title: "Deactivate this line?",
        content:
          "You are about to deactivate the line $primaryDevice from the device $deviceName. You can reactivate this line at any time using the DIGITS app.",
        labelClose: "CANCEL",
        labelAction: "Deactivate",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel",
      },
      pairError: {
        title: "",
        content:
          "We are experiencing technical difficulties. You can wait a few minutes and try again or you can reach out for assistance below.",
        labelClose: "CANCEL",
        labelAction: "OK",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel",
      },
      oops: {
        title: "Oops, our bad",
        content:
          "We are experiencing technical difficulties. You can wait a few minutes and try again or you can reach out for assistance below.",
        labelClose: "CANCEL",
        labelAction: "CONTACT SUPPORT",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel",
      },
      onAsign: {
        title: "Assigning line to yourself?",
        content:
          "By assigning the line to yourself, you will be able to use this line on DIGITS and still be able to share this line with others to use",
        labelClose: "CANCEL",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        labelAction: "Assign to me",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel",
      },
      onAsignError: {
        title: "Assigning line to yourself??",
        content: "Assigning the line with yourself is not successfull.",
        labelClose: "CANCEL",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        labelAction: "Please try again",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel",
      },

      userEXistsError: {
        title: "User already exists.",
        content: "$email already has access to $deviceName",
        labelClose: "",
        closeAction: () => {console.log("")},
        closeActionDisable: false,
        modalActionDisable: false,
        labelAction: "OK",
        isPending: false,
        closeBtnClass: "modelCloseBtn",
        actionBtnClass: "orangeButton",
        dialogClass: "errorModel btnRight",
      },
      success: {
        messageShare: `Your invitation for $deviceName has been sent`,
        messageAssignee: `Your line $deviceName is now ready to use`,
      },
      error: {
        message: "",
      },
      contactHelp: `https://www.t-mobile.com/customers/customer-care`,
    },
    Regex: {
      emailValidation: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
    },
    unPaireTitle:
      "This device is currently unpaired. It will not be able to make or receive calls and texts without first pairing it with a SIM-based Voice line.",
  },
  ManageSignIn: {
    singnout: {
      title: "Sign out on this device?",
      content: "You are about to sign out $DeviceName.",
      labelClose: "CANCEL",
      closeAction: () => {console.log("")},
      closeActionDisable: false,
      modalActionDisable: false,
      labelAction: "SIGN OUT",
      isPending: false,
      closeBtnClass: "modelCloseBtn",
      actionBtnClass: "orangeButton",
      dialogClass: "errorModel",
    },
    singingnout: {
      title: "Sign out on this device?",
      content: "Unpairing...",
      labelClose: "",
      closeAction: () => {console.log("")},
      closeActionDisable: false,
      modalActionDisable: false,
      labelAction: "",
      isPending: false,
      closeBtnClass: "modelCloseBtn",
      actionBtnClass: "orangeButton",
      dialogClass: "managesignin",
    },
    signoutSuccess: {
      title: "Sign out on this device?",
      content: "Device signed out successfully.",
      labelClose: "",
      closeAction: () => {console.log("")},
      closeActionDisable: false,
      modalActionDisable: false,
      labelAction: "OK",
      isPending: false,
      closeBtnClass: "modelCloseBtn",
      actionBtnClass: "orangeButton",
      dialogClass: "manageSucces",
    },
    signoutError404: {
      title: "Sign out on this device?",
      content: "Looks like $DeviceName is already signed-out.",
      labelClose: "OK",
      closeAction: () => {console.log("")},
      closeActionDisable: false,
      modalActionDisable: false,
      labelAction: "Customer Care",
      isPending: false,
      closeBtnClass: "modelCloseBtn",
      actionBtnClass: "orangeButton",
      dialogClass: "errorModel",
    },
    toolTipsTitle: {
      phoneIcon: "Phone or Tablet",
      webIcon: "WebDIGITS",
      alexaIcon: "Alexa",
      BrandGlobal: "Brand Global",
      helpIcon:
        "These are devices that are logged in to DIGITS using your T-Mobile ID.",
    },
  },
  Signout: {
    singingnout: {
      title: "Are you still here?",
      content:
        "For your security you will be logged out after 30 minutes of inactivity.",
      labelClose: "Logout",
      closeAction: () => {console.log("")},
      closeActionDisable: false,
      modalActionDisable: false,
      labelAction: "Stay logged in (3:00)",
      isPending: false,
      closeBtnClass: "modelCloseBtn",
      actionBtnClass: "orangeButton",
      dialogClass: "",
    },
  },
  Home: {
    linesHelperText: {
      Assigned:
        "Assigned lines include any SIM-based Voice and Virtual lines that are part of my account and are assigned for me to use in DIGITS.",
      Unassigned:
        "Unassigned lines include any SIM-based Voice and Virtual lines that are part of my account but that I have not been assigned to. If I assign myself to an Unassigned line it will be available in DIGITS.",
      Paired:
        "Paired Devices are devices using a Data with Paired DIGITS line. Unpaired devices can be paired with existing SIM-based Voice lines.",
      Shared:
        "Lines shared with me are lines that I don’t own that have been shared with me by another account. These lines are all usable in DIGITS.",
    },
    headerTitles: [
      "Paired Devices",
      "Lines assigned to me",
      "Lines not assigned to me",
      "Lines shared with me by others",
    ],
    helpWithDigits:
      "https://www.t-mobile.com/support/plans-features/using-digits",
    contactDigits: "https://www.t-mobile.com/customers/customer-care",
  },
};
